import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const fetchRecipes = createAsyncThunk(
  "recipes/fetchRecipes",
  async () => {
    const response = await axios.get(`${BASE_URL}/api/recipes`);
    return response.data;
  }
);

export const fetchRecipe = createAsyncThunk(
  "recipes/fetchRecipe",
  async (sid) => {
    const response = await axios.get(`${BASE_URL}/api/recipes/${sid}`);
    return response.data;
  }
);

export const createRecipe = createAsyncThunk(
  "recipes/createRecipe",
  async (newRecipe) => {
    const response = await axios.post(`${BASE_URL}/api/recipes`, newRecipe);
    return response.data;
  }
);

export const updateRecipe = createAsyncThunk(
  "books/updateRecipe",
  async (recipeUpdate) => {
    const response = await axios.put(`${BASE_URL}/api/recipes`, recipeUpdate);
    return response.data;
  }
);

export const deleteRecipe = createAsyncThunk(
  "recipes/deleteRecipe",
  async (sid) => {
    const response = await axios.delete(`${BASE_URL}/api/recipes/${sid}`);
    return response.data;
  }
);

const recipeSlice = createSlice({
  name: "recipes",
  initialState: {
    recipes: [],
    recipe: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearRecipes: (state) => {
      state.recipes = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch recipes
      .addCase(fetchRecipes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRecipes.fulfilled, (state, action) => {
        state.recipes = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchRecipes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // fetch recipe
      .addCase(fetchRecipe.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRecipe.fulfilled, (state, action) => {
        state.recipe = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchRecipe.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // create recipe
      .addCase(createRecipe.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createRecipe.fulfilled, (state, action) => {
        state.recipe = action.payload; // created recipe
        state.isLoading = false;
      })
      .addCase(createRecipe.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // update recipe
      .addCase(updateRecipe.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateRecipe.fulfilled, (state, action) => {
        state.recipe = action.payload; // updated recipe
        state.isLoading = false;
      })
      .addCase(updateRecipe.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // delete recipe
      .addCase(deleteRecipe.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteRecipe.fulfilled, (state, action) => {
        state.recipe = null;
        state.isLoading = false;
      })
      .addCase(deleteRecipe.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearRecipes } = recipeSlice.actions;

export default recipeSlice.reducer;
